<template>
  <div class="container">
    <div class="title">
      <i class="iconfont icon-fanhui-" @click="_tobackPage"></i>
      {{ title }}
    </div>
    <div class="body">
      <div class="form">
        <div class="newsTitle" v-for="(item, index) in newsList" :key="index" @click="_toDetailPage(item.a_id_str)">
          <span style="
              color: #1242fc;
              font-size: 16px;
              font-weight: bold;
            ">
          </span>
          {{ item.a_title }}
        </div>
      </div>
      <el-pagination :page-size="10" layout="prev, pager, next" :total="total" @change="_changePage"
        style="margin: 20px 0; display: flex; justify-content: center;" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import http from '@/util/http'

export default {
  name: 'lists',
  data() {
    return {
      title: '',
      newsList: [],
      total: 0,
      currentPage: 1
    }
  },
  mounted() {
    this._getNewsList()
  },
  methods: {
    _tobackPage() {
      this.$router.go(-1)
    },
    _getNewsList(pageNum = 1) {
      const typeId = this.$route.query.id
      console.log(typeId)
      if (typeId == 1) {
        http.get('article/type_01', { pageNum, pageSize: 10 }).then(res => {
          if (res.code == 200) {
            this.newsList = res.data.list
            this.total = res.data.total
            this.title = '国家艾滋病治疗最新消息'
            console.log(res.data.list)
          }
        })
      } else if (typeId == 2) {
        http.get('article/type_02', { pageNum, pageSize: 10 }).then(res => {
          if (res.code == 200) {
            this.newsList = res.data.list
            this.total = res.data.total
            this.title = '当地宣传活动公告'
          }
        })
      }
    },
    _toDetailPage(id) {
      this.$router.push({
        path: '/detail',
        query: {
          id: id
        }
      })
    },
    _changePage(page) {
      this.currentPage = page
      this._getNewsList(page)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  width: 100%;
  height: 70px;
  background-color: #1242fc;
  color: #fff;
  font-size: 18px;
  line-height: 70px;
  text-align: center;
}

.title i {
  float: left;
  margin-left: 10px;
}

.body {
  width: 100%;
  height: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.form {
  /* width: 92%; */
  /* height: 85%; */
  /* background-color: pink; */
  /* border: 2px solid #1242fc; */
  border-radius: 5px;
  /* margin-top: 10px; */
  padding: 10px 0;
  /* overflow: hidden; */
  overflow-y: scroll;
  border: 1px solid #1242fc;
  padding: 0px 20px;
  margin: 20px 20px;
}

.newsTitle {
  padding: 15px 20px;
  border-bottom: 1px solid #D3D0D0;
}
</style>
